// extracted by mini-css-extract-plugin
export default {"chatWindow":"ChatWindow_chatWindow__Pnc7Y","messageList":"ChatWindow_messageList__Ols1-"};